<template>
  <v-card class="d-flex flex-column align-center justify-center pa-5">
    <v-card-title class="mb-5">Επεξεργασία Εργαζομένου</v-card-title>
    <v-form class="form d-flex flex-column justify-center">
      <v-text-field
        label="Όνομα"
        v-model="name"
        :error-messages="nameErrors"
        class="rounded text-body-1 font-weight-regular"
      >
      </v-text-field>

      <v-text-field
        label="Επίθετο"
        v-model="lastName"
        :error-messages="lastNameErrors"
        class="rounded text-body-1 font-weight-regular"
      >
      </v-text-field>

      <v-radio-group label="Σύνδεση" v-model="canLogin">
        <v-radio label="Επιτρέπεται" :value="true"></v-radio>
        <v-radio label="Απογορεύεται" :value="false"></v-radio>
      </v-radio-group>

      <div class="d-flex justify-center mt-16">
        <v-btn
          class="success rounded text-sm-body-1 font-weight-regular mr-5"
          :loading="loader"
          @click="onSubmit"
        >
          <span>Επεξεργασία</span>
        </v-btn>
        <v-btn
          class="secondary rounded text-sm-body-1 font-weight-regular"
          @click="$emit('closeDialog')"
        >
          <span>Επιστροφή</span>
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>
  
  <script>
import { mapState, mapMutations, mapActions } from "vuex";

import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  props: ["currentUser"],

  async created() {
    this.name = this.currentUser.user.firstName;
    this.lastName = this.currentUser.user.lastName;
    this.canLogin = this.currentUser.user.canLogin;

    this.select = this.currentUser.creditInstitutes.map((el) => {
      return {
        text: el.creditInstituteName,
        value: el.creditInstituteId.toUpperCase(),
      };
    });
  },

  data() {
    return {
      name: "",
      lastName: "",
      userName: "",
      email: "",
      canLogin: "",
      select: [],
      loader: false,
    };
  },

  validations: {
    name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(16),
    },
    lastName: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(16),
    },
  },

  computed: {
    ...mapState({
      creditInstitutes: (state) =>
        state.creditInstitutes.creditInstitutes.map((el) => {
          return { text: el.itemValue, value: el.itemKey };
        }),
    }),

    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      if (!this.$v.name.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.name.minLength) errors.push("Τουλάχιστον 3 χαρακτήρες");
      if (!this.$v.name.maxLength) errors.push("Μέχρι 16 χαρακτήρες");
      return errors;
    },

    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      if (!this.$v.lastName.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.lastName.minLength) errors.push("Τουλάχιστον 3 χαρακτήρες");
      if (!this.$v.lastName.maxLength) errors.push("Μέχρι 16 χαρακτήρες");
      return errors;
    },
  },

  methods: {
    ...mapMutations(["updateEditHcmcDialog"]),
    ...mapActions(["getCreditInstitutes", "editHcmcUser"]),

    async onSubmit() {
      try {
        const creditInstitutes = this.select.map((el) => {
          return {
            creditInstituteId: el.value,
          };
        });
        this.$v.$touch();
        if (this.$v.$invalid) return;
        this.loader = true;

        // await this.editHcmcUser({
        //   hcmcEmployeeId: this.currentUser.hcmcEmployeeId,
        //   user: {
        //     firstName: this.name,
        //     lastName: this.lastName,
        //     canLogin: this.canLogin,
        //   },
        // });

        this.loader = false;

        this.$emit("closeDialog");
      } catch {
        this.loader = false;
      }
    },
  },
};
</script>
  
  <style scoped lang="scss">
.form {
  width: 500px;
}
</style>